export function logForDev(...args: any[]) {
  const isDev = !(process.env.RELEASE_STAGE === 'live');

  if (isDev && console) console.log(...args); // eslint-disable-line no-console
}
